export default __webpack_public_path__ + "static/media/1.8da6e978.png";